import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 md:py-24 px-5 sm:px-6 md:px-8 bg-carbon" data-id="element-218">
      <div className="max-w-4xl mx-auto" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="bg-[#0a0a0a] border border-gold/30 p-8 md:p-12 rounded-2xl text-center shadow-[0_0_30px_rgba(242,183,5,0.05)] relative overflow-hidden" data-id="element-220">
          {/* Subtle background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-md max-h-md bg-gold/5 blur-3xl rounded-full pointer-events-none" data-id="element-221"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-222">
            <div className="w-20 h-20 md:w-24 md:h-24 bg-emerald/10 rounded-full flex items-center justify-center mb-6 md:mb-8" data-id="element-223">
              <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-emerald" data-id="element-224" />
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gold mb-6" data-id="element-225">
              Nuestra Garantía
            </h2>

            <p className="text-lg md:text-2xl text-white font-medium leading-relaxed max-w-3xl" data-id="element-226">
              Si en los primeros 30 días no ves un incremento medible en citas
              agendadas y una reducción significativa de No-Shows,{' '}
              <span className="text-gold" data-id="element-227">
                trabajamos gratis hasta que lo logres.
              </span>{' '}
              Sin letra pequeña. Sin excusas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}